module.exports = __webpack_public_path__ + "img/mxr-fullbore-metal.edb5f793.jpg";